
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pengelolaan-kinerja-dinas/perencanaan/detail",
      function () {
        return require("private-next-pages/pengelolaan-kinerja-dinas/perencanaan/detail/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pengelolaan-kinerja-dinas/perencanaan/detail"])
      });
    }
  